export interface Establishment {
  id: string;
  locationId: string;

  name: string;
  address: string;

  phone: string;
  email: string;
  website: string;
  twitter: string;
  instagram: string;

  contactNames: Contact[];
  contactEmails: Contact[];
  contactPhones: Contact[];

  contactName: string;
  contactEmail: string;
  contactPhone: string;

  latitude: number;
  longitude: number;
}

export interface Contact {
  id: string;
  value: string;
  isDefault: boolean;
}

export function emptyContact(): Contact {
  return {
    id: null,
    value: null,
    isDefault: false,
  };
}

export function emptyEstablishment(): Establishment {
  return {
    id: null,
    locationId: null,

    name: null,
    address: null,

    phone: null,
    email: null,
    website: null,
    twitter: null,
    instagram: null,

    contactEmails: [],
    contactNames: [],
    contactPhones: [],

    contactEmail: null,
    contactName: null,
    contactPhone: null,

    latitude: null,
    longitude: null,
  };
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/offers/interfaces/establishments.interfaces.ts